export default "__VITE_ASSET__4RWvpFjC__"